
<template>
    <div>
        <div class="row">
            <div class="col-12">
                <q-checkbox color="teal-14" v-model="Agree" @input="Agreed()">{{$t("stepper.decl")}}
                 <q-btn @click="Declaration = true" unelevated outline round size="xs" color="primary" icon="fas fa-info" class="q-ml-sm" style="font-size: 5px;"></q-btn>
                <!-- <q-icon name="info" @click="Declaration=true"/> -->
                </q-checkbox>
            </div>
        </div>
        
        <q-dialog v-model="Declaration">
         <q-card >
                <q-card-section class="row items-center q-pb-none">
                    <q-btn icon="close" flat round dense v-close-popup style="margin-left: auto !important;"/>										
				</q-card-section>
                <q-card-section style="padding: 1.5rem;">
                    <Declaration/>
                </q-card-section>
                <q-separator/>
                <q-card-section class="text-right">
                    <q-btn flat color="primary" label="OK" @click="Declaration = false"/>
                </q-card-section>
         </q-card>
      </q-dialog>
    </div>
</template>

<style>
.q-checkbox__label.q-anchor--skip {
    padding-left: 0.5rem;
}
</style>

<script>
import { mapActions } from 'vuex';
import store from '../store'
import Declaration from '@/components/Declaration'
export default {
    name : 'DeclarationCheckBox',
    components : {
        Declaration
    },
    data() {
        return {
            Agree : false,
            Declaration : false
        }
    },
    computed: {

    },
    methods: {
        Agreed(){
            this.$emit('Agreed')
        }
        
    },
}
</script>